export default "__VITE_ASSET__kAU_Z0_B__"